import React from "react";
import "./index.scss";
import { Button } from "react-bootstrap";
import { FilterIcon } from "../../assets/images/svg/svg";

function pageFilterHeader({ title, FilterComponent }) {
  //TODO: Review remove this from here and make css in global
  return (
    <div className="header-main">
      <div className="header-left">
        <h3>{title}</h3>
      </div>
      <div className="header-right">
        {FilterComponent && <FilterComponent />}
      </div>
    </div>
  );
}

export default pageFilterHeader;
